import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CartService } from './cart.service';
import { CampaignType } from './campaign.types';

export type AppState = 'state-neutral' | 'state-pumps' | 'state-airconditioners';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor(
    private cartService: CartService
  ) { }

  private stateSubject = new BehaviorSubject<AppState>('state-neutral');
  state$ = this.stateSubject.asObservable();

  setState(state: AppState) {
    // console.log("state ", state);
    this.stateSubject.next(state);
    this.updateBodyClass(state);
    this.cartService.resetCartState();
  }

  setStatePumps(){
    const state = 'state-pumps';
    this.stateSubject.next(state);
    this.updateBodyClass(state);
    this.cartService.resetCartState();
  }

  setStateAirconditioners(){
    const state = 'state-airconditioners';
    this.stateSubject.next(state);
    this.updateBodyClass(state);
    this.cartService.resetCartState();
  }

  private updateBodyClass(state: AppState) {
    document.body.classList.remove('state-neutral', 'state-pumps', 'state-airconditioners');
    document.body.classList.add(`${state}`);
  }

  getState(): AppState {
    return this.stateSubject.getValue();
  }

  // Mapuje stan aplikacji na typ kampanii. Stan neutralny nie ma kampanii (null).
  // To jedyne źródło tłumaczenia AppState -> CampaignType.
  getCampaignType(): CampaignType | null {
    const state = this.getState();
    if (state === 'state-pumps') return 'pumps';
    if (state === 'state-airconditioners') return 'airconditioners';
    return null;
  }

  resetState() {
    console.log("resetState");
    this.setState('state-neutral');
  }
}
